// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Metadata about the export — when it was created, by whom, and
 * which stages are included.
 */
export class ExportMeta implements flatbuffers.IUnpackableObject<ExportMetaT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ExportMeta {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsExportMeta(bb: flatbuffers.ByteBuffer, obj?: ExportMeta): ExportMeta {
    return (obj || new ExportMeta()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsExportMeta(bb: flatbuffers.ByteBuffer, obj?: ExportMeta): ExportMeta {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ExportMeta()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * Schema version for forward compatibility. Increment on
   * breaking changes to any archive table.
   *
   * version 3: `ChannelModifiers` added as new stage between Banks and
   * `LiftsFloors`, shifting every later stage by +1.
   * version 4: Per-role scope grants (RoleBankPermission /
   * RoleLiftPermission / RoleFloorPermission) added as Stage 9 (cont.)
   * vectors at the end of OrgExport and as nested vectors on Role.
   * Additive only — no stage renumbering.
   * version 5: `TimedActions` added as a new wizard stage. The
   * `timed_actions` vector is appended at the END of OrgExport and the new
   * stage constant is inserted just before the `StageReview` sentinel, so no
   * existing real stage ID shifts and previously-exported .lnx files remain
   * importable. Additive only — no stage renumbering.
   * version 6: Cross-org reachability grants (RoleOrgGrant) added as a
   * `role_org_grants` vector appended at the END of OrgExport and as a nested
   * `org_grants` vector on Role. Additive only — no stage renumbering, and a
   * v5 reader simply ignores the new vector. Note the default is SAFE in the
   * direction that matters: absent org grants mean "own subtree only", so an
   * older export importing into a v6 consumer under-grants rather than
   * over-grants.
   *
   * version 8: `ControlRoutes` / `ControlRouteTargets` added for merged-channel
   * Control write routing. Both vectors are appended at the END of OrgExport
   * and no new wizard stage constant is introduced (the rules are configured
   * within Stage 4, Channels), so no existing stage ID shifts and previously
   * exported .lnx files stay importable. Additive only.
   *
   * The DECLARED DEFAULT stays 5 deliberately. A table field's default is what
   * a reader assumes when the field is ABSENT from the buffer, so raising it
   * would retroactively reinterpret every older export that omitted the field
   * as claiming a version it predates. fbconform flags exactly this
   * (`field_default_changed`) and it is right to: it is a real compatibility
   * break, not a bookkeeping detail. Exporters write the current version
   * explicitly; this number only describes the floor for buffers that carry
   * no version at all.
   * version 7: `Message` and `MessageType` added. `action_catalogs`.message_id
   * and `action_banks`.message_id/toggle_message_id are FK references into
   * `messages` (and messages.message_type_id into message_types) that no
   * prior version captured, so a re-imported `action_catalog`/`action_bank` could
   * reference a message row the export never included. Documented as 7 rather
   * than the 6 it carried on `flattened-valued-messages`: `RoleOrgGrant` had
   * already taken 6 on the release line, and two features cannot share a
   * number. Additive only — no stage renumbering.
   * version 9: `Server`.site_network added — the NICs, bonds, VLANs, routes
   * and routing-policy rules an edge server applies at first boot. Additive
   * only; no stage renumbering. Recorded because an importer built before it
   * drops the field silently on a round trip, and `servers` is exported at
   * stage 1, so the loss is not visible until the box is provisioned.
   * version 10: `WizardDraft` added — the setup wizard's unsaved step state
   * (`wizard_drafts`), so a draft organization exports with its work in
   * progress. Appended at the END of OrgExport; no new wizard stage constant
   * (drafts belong to whichever step they were saved from), so no stage
   * renumbering. An importer built before it drops the drafts silently.
   */
  version(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 5;
  }

  /**
   * ISO 8601 timestamp of when the export was generated.
   */
  exportedAt(): string;
  exportedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  exportedAt(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  /**
   * Source organization ID.
   */
  orgId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Human-readable organization name.
   */
  orgName(): string;
  orgName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  orgName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  /**
   * Which wizard stages (0-11) are included in this export.
   * An empty vector means all stages are included.
   */
  stagesIncluded(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb!.__vector(this.bb_pos + offset) + index * 4) : 0;
  }

  stagesIncludedLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  stagesIncludedArray(): Int32Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? new Int32Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  /**
   * Whether stage dependencies were auto-included.
   */
  includeDeps(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  /**
   * If non-null, export was scoped to a single server.
   */
  serverId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startExportMeta(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addVersion(builder: flatbuffers.Builder, version: number) {
    builder.addFieldInt32(0, version, 5);
  }

  static addExportedAt(builder: flatbuffers.Builder, exportedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, exportedAtOffset, 0);
  }

  static addOrgId(builder: flatbuffers.Builder, orgIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, orgIdOffset, 0);
  }

  static addOrgName(builder: flatbuffers.Builder, orgNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, orgNameOffset, 0);
  }

  static addStagesIncluded(builder: flatbuffers.Builder, stagesIncludedOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, stagesIncludedOffset, 0);
  }

  static createStagesIncludedVector(
    builder: flatbuffers.Builder,
    data: number[] | Int32Array,
  ): flatbuffers.Offset;
  /**
   * @deprecated This Uint8Array overload will be removed in the future.
   */
  static createStagesIncludedVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset;
  static createStagesIncludedVector(
    builder: flatbuffers.Builder,
    data: number[] | Int32Array | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt32(data[i]!);
    }
    return builder.endVector();
  }

  static startStagesIncludedVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addIncludeDeps(builder: flatbuffers.Builder, includeDeps: boolean) {
    builder.addFieldInt8(5, +includeDeps, +true);
  }

  static addServerId(builder: flatbuffers.Builder, serverIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, serverIdOffset, 0);
  }

  static endExportMeta(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // exported_at
    builder.requiredField(offset, 8); // org_id
    builder.requiredField(offset, 10); // org_name
    return offset;
  }

  unpack(): ExportMetaT {
    return new ExportMetaT(
      this.version(),
      this.exportedAt(),
      this.orgId() !== null ? this.orgId()!.unpack() : null,
      this.orgName(),
      this.bb!.createScalarList<number>(
        this.stagesIncluded.bind(this),
        this.stagesIncludedLength(),
      ),
      this.includeDeps(),
      this.serverId() !== null ? this.serverId()!.unpack() : null,
    );
  }

  unpackTo(_o: ExportMetaT): void {
    _o.version = this.version();
    _o.exportedAt = this.exportedAt();
    _o.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    _o.orgName = this.orgName();
    _o.stagesIncluded = this.bb!.createScalarList<number>(
      this.stagesIncluded.bind(this),
      this.stagesIncludedLength(),
    );
    _o.includeDeps = this.includeDeps();
    _o.serverId = this.serverId() !== null ? this.serverId()!.unpack() : null;
  }

  unpackFields(...fields: string[]): ExportMetaT {
    const t = new ExportMetaT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("version")) {
      t.version = this.version();
    }
    if (fieldSet.has("exported_at")) {
      t.exportedAt = this.exportedAt();
    }
    if (fieldSet.has("org_id")) {
      t.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    }
    if (fieldSet.has("org_name")) {
      t.orgName = this.orgName();
    }
    if (fieldSet.has("stages_included")) {
      t.stagesIncluded = this.bb!.createScalarList<number>(
        this.stagesIncluded.bind(this),
        this.stagesIncludedLength(),
      );
    }
    if (fieldSet.has("include_deps")) {
      t.includeDeps = this.includeDeps();
    }
    if (fieldSet.has("server_id")) {
      t.serverId = this.serverId() !== null ? this.serverId()!.unpack() : null;
    }
    return t;
  }
}

export class ExportMetaT implements flatbuffers.IGeneratedObject {
  constructor(
    public version: number = 5,
    public exportedAt: string | Uint8Array | null = null,
    public orgId: UuidT | null = null,
    public orgName: string | Uint8Array | null = null,
    public stagesIncluded: number[] = [],
    public includeDeps: boolean = true,
    public serverId: UuidT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.exportedAt === null || this.exportedAt === undefined) {
      throw new Error('Required field "exported_at" is not set');
    }
    if (this.orgId === null || this.orgId === undefined) {
      throw new Error('Required field "org_id" is not set');
    }
    if (this.orgName === null || this.orgName === undefined) {
      throw new Error('Required field "org_name" is not set');
    }
    const exportedAt = this.exportedAt !== null ? builder.createString(this.exportedAt!) : 0;
    const orgId = this.orgId !== null ? this.orgId!.pack(builder) : 0;
    const orgName = this.orgName !== null ? builder.createString(this.orgName!) : 0;
    const stagesIncluded = ExportMeta.createStagesIncludedVector(builder, this.stagesIncluded);
    const serverId = this.serverId !== null ? this.serverId!.pack(builder) : 0;

    ExportMeta.startExportMeta(builder);
    ExportMeta.addVersion(builder, this.version);
    ExportMeta.addExportedAt(builder, exportedAt);
    ExportMeta.addOrgId(builder, orgId);
    ExportMeta.addOrgName(builder, orgName);
    ExportMeta.addStagesIncluded(builder, stagesIncluded);
    ExportMeta.addIncludeDeps(builder, this.includeDeps);
    ExportMeta.addServerId(builder, serverId);

    return ExportMeta.endExportMeta(builder);
  }

  clone(): ExportMetaT {
    const obj = new ExportMetaT();
    obj.version = this.version;
    obj.exportedAt = this.exportedAt;
    obj.orgId = this.orgId !== null ? this.orgId!.clone() : null;
    obj.orgName = this.orgName;
    obj.stagesIncluded = [...this.stagesIncluded];
    obj.includeDeps = this.includeDeps;
    obj.serverId = this.serverId !== null ? this.serverId!.clone() : null;
    return obj;
  }

  equals(other: ExportMetaT): boolean {
    if (this.version !== other.version) return false;
    if (this.exportedAt !== other.exportedAt) return false;
    if (this.orgId !== null && other.orgId !== null) {
      if (!this.orgId!.equals(other.orgId!)) return false;
    } else if (this.orgId !== other.orgId) return false;
    if (this.orgName !== other.orgName) return false;
    if (this.stagesIncluded.length !== other.stagesIncluded.length) return false;
    for (let i = 0; i < this.stagesIncluded.length; i++) {
      if (this.stagesIncluded[i] !== other.stagesIncluded[i]) return false;
    }
    if (this.includeDeps !== other.includeDeps) return false;
    if (this.serverId !== null && other.serverId !== null) {
      if (!this.serverId!.equals(other.serverId!)) return false;
    } else if (this.serverId !== other.serverId) return false;
    return true;
  }
}

export function verifyExportMeta(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "exported_at");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "org_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "org_name");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkVector(pos, 4);
      }
    }
    verifier.checkScalarField(tablePos, 14, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 16);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
